import { CircleDot, Loader2, CheckCircle2, XCircle, Circle, AlertTriangle, PauseCircle, HelpCircle } from "lucide-react";

// Wiederverwendbare Status-Badges. Status wird NIE nur über Farbe kommuniziert –
// immer mit Text und Symbol (Barrierefreiheit).
const STATUS_MAP = {
  neu: { label: "Neu", tone: "info", icon: CircleDot },
  in_bearbeitung: { label: "In Bearbeitung", tone: "warning", icon: Loader2 },
  qualifiziert: { label: "Qualifiziert", tone: "info", icon: CheckCircle2 },
  gewonnen: { label: "Gewonnen", tone: "success", icon: CheckCircle2 },
  verloren: { label: "Verloren", tone: "danger", icon: XCircle },
  aktiv: { label: "Aktiv", tone: "success", icon: CircleDot },
  inaktiv: { label: "Inaktiv", tone: "neutral", icon: PauseCircle },
  ueberfaellig: { label: "Überfällig", tone: "danger", icon: AlertTriangle },
  offen: { label: "Offen", tone: "neutral", icon: Circle },
  erledigt: { label: "Erledigt", tone: "success", icon: CheckCircle2 },
  // Kunden-Kategorien
  Kunde: { label: "Kunde", tone: "success", icon: CircleDot },
  Interessent: { label: "Interessent", tone: "info", icon: CircleDot },
  Lieferant: { label: "Lieferant", tone: "neutral", icon: CircleDot },
};

const TONES = {
  success: "bg-success/10 text-success border-success/20",
  warning: "bg-warning/10 text-warning border-warning/25",
  danger: "bg-destructive/10 text-destructive border-destructive/20",
  info: "bg-info/10 text-info border-info/20",
  neutral: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ status, label, tone: toneProp, icon: IconProp, className = "" }) {
  const key = String(status || "").toLowerCase().replace(/\s|-/g, "_");
  const cfg = STATUS_MAP[status] || STATUS_MAP[key] || { label: label || status, tone: "neutral", icon: HelpCircle };
  const tone = toneProp || cfg.tone;
  const Icon = IconProp || cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${TONES[tone] || TONES.neutral} ${className}`}
      data-testid={`status-badge-${key}`}
    >
      {Icon && <Icon className="w-3 h-3" strokeWidth={2} aria-hidden="true" />}
      {label || cfg.label}
    </span>
  );
}

export default StatusBadge;
